import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import Button from '../../components/base/Button';
import SEOHead from '../../components/SEO/SEOHead';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ProductsPage() {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const seoData = {
    title: 'محصولات گلخانه سبز آریا - تجهیزات کامل گلخانه | کوکوپیت، نخ یووی، توری ضد تریپس',
    description: 'مجموعه کامل محصولات و تجهیزات گلخانه شامل کوکوپیت درجه یک، نخ یووی دار مقاوم، توری ضد تریپس، چسب ترمیم پلاستیک، هیتر گلخانه و سایر تجهیزات پیشرفته با کیفیت اروپایی.',
    keywords: 'محصولات گلخانه، تجهیزات گلخانه، کوکوپیت، نخ یووی دار، توری ضد تریپس، چسب ترمیم پلاستیک، هیتر گلخانه، پیت ماس، سیستم آبیاری، کنترل اقلیم، اتوماسیون گلخانه، تجهیزات هیدروپونیک، فروش تجهیزات گلخانه',
    ogImage: 'https://public.readdy.ai/ai/img_res/5a5085d095a8687f799d497d4f79b088.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "محصولات گلخانه سبز آریا",
      "description": "مجموعه کامل تجهیزات و محصولات گلخانه",
      "provider": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "کاتالوگ محصولات گلخانه",
        "itemListElement": [
          {
            "@type": "Product",
            "name": "کوکوپیت درجه یک",
            "description": "بستر کشت ارگانیک با کیفیت بالا",
            "category": "بستر کشت",
            "url": "https://ariagreenhouse.com/products/1",
            "brand": {
              "@type": "Brand",
              "name": "گلخانه سبز آریا"
            },
            "offers": {
              "@type": "Offer",
              "url": "https://ariagreenhouse.com/products/1",
              "availability": "https://schema.org/InStock",
              "price": "250000",
              "priceCurrency": "IRR",
              "seller": {
                "@type": "Organization",
                "name": "آریا گرین هاوس"
              }
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "156"
            }
          },
          {
            "@type": "Product",
            "name": "نخ یووی دار",
            "description": "نخ مقاوم در برابر اشعه UV",
            "category": "تجهیزات نگهداری",
            "url": "https://ariagreenhouse.com/products/3",
            "brand": {
              "@type": "Brand",
              "name": "گلخانه سبز آریا"
            },
            "offers": {
              "@type": "Offer",
              "url": "https://ariagreenhouse.com/products/3",
              "availability": "https://schema.org/InStock",
              "price": "85000",
              "priceCurrency": "IRR",
              "seller": {
                "@type": "Organization",
                "name": "آریا گرین هاوس"
              }
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "89"
            }
          },
          {
            "@type": "Product",
            "name": "توری ضد تریپس",
            "description": "محافظت از گیاهان در برابر آفات",
            "category": "محافظت گیاهان",
            "url": "https://ariagreenhouse.com/products/4",
            "brand": {
              "@type": "Brand",
              "name": "گلخانه سبز آریا"
            },
            "offers": {
              "@type": "Offer",
              "url": "https://ariagreenhouse.com/products/4",
              "availability": "https://schema.org/InStock",
              "price": "120000",
              "priceCurrency": "IRR",
              "seller": {
                "@type": "Organization",
                "name": "آریا گرین هاوس"
              }
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "124"
            }
          }
        ]
      }
    }
  };

  const categories = [
    { id: 'all', name: t('products.cat.all'), icon: 'ri-apps-line' },
    { id: 'substrates', name: t('products.cat.substrates'), icon: 'ri-seedling-line' },
    { id: 'support', name: t('products.cat.support'), icon: 'ri-plant-line' },
    { id: 'protection', name: t('products.cat.protection'), icon: 'ri-shield-line' },
    { id: 'heating', name: t('products.cat.heating'), icon: 'ri-fire-line' },
    { id: 'covering', name: 'پوشش گلخانه', icon: 'ri-home-4-line' },
    { id: 'structure', name: 'سازه و اتصالات', icon: 'ri-building-line' },
    { id: 'irrigation', name: 'سیستم‌های آبیاری', icon: 'ri-drop-line' },
    { id: 'tools', name: t('products.cat.tools'), icon: 'ri-tools-line' }
  ];

  const getProductData = () => {
    const currentLang = localStorage.getItem('i18nextLng') || 'fa';
    
    if (currentLang === 'en') {
      return [
        {
          id: 1,
          name: 'Premium Coconut Coir',
          category: 'substrates',
          price: '$25',
          image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=400&height=300&seq=coco-premium&orientation=landscape',
          description: 'Natural and organic growing medium from high-quality coconut fiber',
          features: ['100% Natural & Organic', 'Excellent Water Retention', 'Good Aeration', 'Balanced pH', 'Reusable'],
          specifications: {
            'Volume': '5 kg',
            'Moisture': '15-20%',
            'pH': '5.5-6.5',
            'EC': '< 0.5 mS/cm'
          }
        },
        {
          id: 2,
          name: 'Canadian Peat Moss',
          category: 'substrates',
          price: '$32',
          image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20white%20background%20high%20resolution%20product%20photography&width=400&height=300&seq=peat-canadian&orientation=landscape',
          description: 'Special greenhouse soil with Canadian quality',
          features: ['Canadian Quality', 'High Moisture Retention', 'Light Structure', 'Pest Free', 'Suitable for All Plants'],
          specifications: {
            'Volume': '3.8 cubic feet',
            'Moisture': '45-55%',
            'pH': '3.5-4.5',
            'Decomposition': 'H2-H4'
          }
        },
        {
          id: 3,
          name: 'UV Greenhouse Twine',
          category: 'support',
          price: '$8.5',
          image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography%20strong%20durable%20material&width=400&height=300&seq=uv-twine&orientation=landscape',
          description: 'UV resistant twine for plant support',
          features: ['UV Resistant', 'High Strength', 'Flexible', 'Waterproof', 'Recyclable'],
          specifications: {
            'Length': '500 meters',
            'Thickness': '2 mm',
            'Tensile Strength': '15 kg',
            'Material': 'Polypropylene'
          }
        }
      ];
    } else if (currentLang === 'ar') {
      return [
        {
          id: 1,
          name: 'ألياف جوز الهند المميزة',
          category: 'substrates',
          price: '250,000 ريال',
          image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=400&height=300&seq=coco-premium&orientation=landscape',
          description: 'وسط نمو طبيعي وعضوي من ألياف جوز الهند عالية الجودة',
          features: ['100% طبيعي وعضوي', 'احتفاظ ممتاز بالماء', 'تهوية جيدة', 'pH متوازن', 'قابل لإعادة الاستخدام'],
          specifications: {
            'الحجم': '5 كيلوغرام',
            'الرطوبة': '15-20%',
            'pH': '5.5-6.5',
            'EC': '< 0.5 mS/cm'
          }
        },
        {
          id: 2,
          name: 'طحلب الخث الكندي',
          category: 'substrates',
          price: '320,000 ريال',
          image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20white%20background%20high%20resolution%20product%20photography&width=400&height=300&seq=peat-canadian&orientation=landscape',
          description: 'تربة خاصة للبيوت المحمية بجودة كندية',
          features: ['جودة كندية', 'احتفاظ عالي بالرطوبة', 'هيكل خفيف', 'خالي من الآفات', 'مناسب لجميع النباتات'],
          specifications: {
            'الحجم': '3.8 قدم مكعب',
            'الرطوبة': '45-55%',
            'pH': '3.5-4.5',
            'درجة التحلل': 'H2-H4'
          }
        },
        {
          id: 3,
          name: 'خيط البيت المحمي المقاوم للأشعة فوق البنفسجية',
          category: 'support',
          price: '85,000 ريال',
          image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography%20strong%20durable%20material&width=400&height=300&seq=uv-twine&orientation=landscape',
          description: 'خيط مقاوم للأشعة فوق البنفسجية لدعم النباتات',
          features: ['مقاوم للأشعة فوق البنفسجية', 'قوة عالية', 'مرن', 'مقاوم للماء', 'قابل للتدوير'],
          specifications: {
            'الطول': '500 متر',
            'السماكة': '2 مم',
            'قوة الشد': '15 كيلوغرام',
            'المادة': 'بولي بروبيلين'
          }
        }
      ];
    } else if (currentLang === 'ru') {
      return [
        {
          id: 1,
          name: 'Премиум кокосовое волокно',
          category: 'substrates',
          price: '2500 руб',
          image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=400&height=300&seq=coco-premium&orientation=landscape',
          description: 'Натуральная и органическая среда для выращивания из высококачественного кокосового волокна',
          features: ['100% натуральный и органический', 'Отличное удержание воды', 'Хорошая аэрация', 'Сбалансированный pH', 'Многоразовое использование'],
          specifications: {
            'Объем': '5 кг',
            'Влажность': '15-20%',
            'pH': '5.5-6.5',
            'EC': '< 0.5 mS/cm'
          }
        },
        {
          id: 2,
          name: 'Канадский торфяной мох',
          category: 'substrates',
          price: '3200 руб',
          image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20white%20background%20high%20resolution%20product%20photography&width=400&height=300&seq=peat-canadian&orientation=landscape',
          description: 'Специальная тепличная почва канадского качества',
          features: ['Канадское качество', 'Высокое удержание влаги', 'Лёгкая структура', 'Без вредителей', 'Подходит для всех растений'],
          specifications: {
            'Объём': '3.8 кубических фута',
            'Влажность': '45-55%',
            'pH': '3.5-4.5',
            'Степень разложения': 'H2-H4'
          }
        },
        {
          id: 3,
          name: 'UV-стойкий тепличный шпагат',
          category: 'support',
          price: '850 руб',
          image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography%20strong%20durable%20material&width=400&height=300&seq=uv-twine&orientation=landscape',
          description: 'UV-стойкий шпагат для поддержки растений',
          features: ['UV-стойкий', 'Высокая прочность', 'Гибкий', 'Водостойкий', 'Перерабатываемый'],
          specifications: {
            'Длина': '500 метров',
            'Толщина': '2 мм',
            'Прочность на разрыв': '15 кг',
            'Материал': 'Полипропилен'
          }
        }
      ];
    } else {
      // Persian (default)
      return [
        {
          id: 18,
          name: 'قلاب فلزی تکشیار و دوشیار',
          category: 'tools',
          price: '۱۲۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=close%20up%20realistic%20galvanized%20steel%20metal%20hooks%20for%20greenhouse%20plant%20support%20shiny%20silver%20metallic%20m%20shaped%20hooks%20single%20and%20double%20wire%20hanging%20clips%20professional%20agricultural%20hardware%20product%20on%20white%20background%20macro%20photography%20sharp%20details&width=400&height=300&seq=metal-hooks-realistic-v2&orientation=landscape',
          description: 'قلاب‌های فلزی گالوانیزه تکشیار و دوشیار برای نگهداری و آویزان کردن گیاهان در گلخانه',
          features: ['گالوانیزه ضد زنگ', 'تکشیار و دوشیار', 'مقاومت بالا', 'نصب آسان', 'قابل استفاده مجدد'],
          specifications: {
            'جنس': 'فولاد گالوانیزه',
            'نوع': 'تکشیار و دوشیار',
            'قطر سیم': '۳-۴ میلی‌متر',
            'ظرفیت بار': '۵-۱۰ کیلوگرم',
            'بسته‌بندی': '۱۰۰ عددی'
          }
        },
        {
          id: 17,
          name: 'سیستم‌های مه‌پاش و آبیاری',
          category: 'irrigation',
          price: '۲,۸۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=modern%20greenhouse%20misting%20and%20irrigation%20system%20high%20pressure%20fogger%20nozzles%20drip%20irrigation%20sprinkler%20system%20professional%20agricultural%20equipment%20clean%20white%20background%20product%20photography&width=400&height=300&seq=irrigation-systems&orientation=landscape',
          description: 'مجموعه کامل سیستم‌های مه‌پاش و آبیاری شامل مه‌پاش فشار بالا، قطره‌ای، اسپرینکلر و نازل‌های مه‌پاش',
          features: ['کنترل دقیق رطوبت', 'صرفه‌جویی ۴۰٪ آب', 'پوشش یکنواخت', 'نصب آسان', 'دوام بالا'],
          specifications: {
            'فشار کاری': '۳-۸ بار',
            'دبی': '۱۰-۵۰ لیتر/ساعت',
            'پوشش': '۵۰-۲۰۰ متر مربع',
            'جنس': 'استیل ضد زنگ و PVC',
            'گارانتی': '۲ سال'
          }
        },
        {
          id: 16,
          name: 'سینی نشا ترک (۲۸ تا ۲۵۶ حفره)',
          category: 'tools',
          price: '۱۸۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=professional%20greenhouse%20seedling%20trays%20multiple%20sizes%20black%20plastic%20nursery%20trays%20with%20cells%2028%2048%2070%2077%20128%20256%20holes%20agricultural%20equipment%20clean%20white%20background%20high%20quality%20product%20photography&width=400&height=300&seq=seedling-trays-turkish&orientation=landscape',
          description: 'مجموعه کامل سینی‌های نشا ترک با ۶ سایز مختلف: ۲۸، ۴۸، ۷۰، ۷۷، ۱۲۸ و ۲۵۶ حفره',
          features: ['۶ سایز مختلف', 'جنس پلاستیک مقاوم', 'زهکشی مناسب', 'قابل شستشو', 'قابل استفاده مجدد'],
          specifications: {
            'سایزها': '۲۸، ۴۸، ۷۰، ۷۷، ۱۲۸، ۲۵۶ حفره',
            'جنس': 'پلاستیک PS',
            'رنگ': 'مشکی',
            'ابعاد استاندارد': '۵۴×۲۸ سانتی‌متر',
            'ضخامت': '۱.۵-۲ میلی‌متر'
          }
        },
        {
          id: 15,
          name: 'هیترهای گلخانه (۱۰۰-۳۲۰ هزار کالری)',
          category: 'heating',
          price: '۱,۲۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=industrial%20greenhouse%20spot%20cooler%20heater%20with%20three%20large%20metal%20ducts%20on%20top%20blue%20and%20silver%20body%20portable%20unit%20on%20wheels%20professional%20HVAC%20equipment%20for%20agricultural%20use%20warehouse%20setting&width=400&height=300&seq=heaters-industrial-real&orientation=landscape',
          description: 'مجموعه کامل هیترهای گلخانه با ظرفیت‌های ۱۰۰، ۱۵۰، ۲۵۰ و ۳۲۰ هزار کالری',
          features: ['۴ مدل مختلف', 'گرمایش یکنواخت', 'صرفه‌جویی انرژی ۳۰٪', 'کنترل دقیق دما', 'عمر طولانی ۱۰ سال'],
          specifications: {
            'مدل‌ها': '۱۰۰، ۱۵۰، ۲۵۰، ۳۲۰ هزار کالری',
            'پوشش': '۲۰ تا ۶۵ متر مربع',
            'ولتاژ': '۲۲۰ ولت',
            'سوخت': 'گاز طبیعی/مایع',
            'گارانتی': '۲ سال'
          }
        },
        {
          id: 14,
          name: 'لوله و اتصالات سازه گلخانه',
          category: 'structure',
          price: '۱,۲۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=greenhouse%20steel%20pipe%20structure%20framework%20galvanized%20metal%20tubes%20and%20connectors%20professional%20agricultural%20construction%20materials%20various%20sizes%20clean%20white%20background%20industrial%20product%20photography&width=400&height=300&seq=structure-pipes&orientation=landscape',
          description: 'مجموعه کامل لوله‌ها و اتصالات گالوانیزه برای ساخت سازه گلخانه',
          features: ['گالوانیزه گرم', 'مقاوم در برابر زنگ', 'استحکام بالا', 'اتصالات استاندارد', 'نصب آسان'],
          specifications: {
            'جنس': 'فولاد گالوانیزه',
            'قطرها': '۲۵، ۳۲، ۴۰، ۵۰ میلی‌متر',
            'ضخامت': '۱.۵-۲ میلی‌متر',
            'طول استاندارد': '۶ متر',
            'استاندارد': 'DIN 2440'
          }
        },
        {
          id: 12,
          name: 'پلاستیک ۳ لایه گلخانه',
          category: 'covering',
          price: '۳۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=three%20layer%20greenhouse%20plastic%20film%20covering%20material%20transparent%20agricultural%20polyethylene%20sheet%20UV%20resistant%20professional%20product%20photography%20clean%20white%20background%20high%20quality%20detailed%20texture&width=400&height=300&seq=plastic-3layer&orientation=landscape',
          description: 'پوشش پلاستیکی ۳ لایه با کیفیت بالا برای گلخانه',
          features: ['ضد قطره (Anti-drip)', 'ضد مه (Anti-fog)', 'محافظت UV ۱۰%', 'عبور نور ۸۵%', 'عمر مفید ۳ سال'],
          specifications: {
            'ضخامت': '۲۰۰ میکرون',
            'عرض': '۸ متر',
            'طول': '۱۰۰ متر',
            'عمر مفید': '۳ سال',
            'محافظت UV': '۱۰%'
          }
        },
        {
          id: 13,
          name: 'پلاستیک ۵ لایه گلخانه',
          category: 'covering',
          price: '۵۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=five%20layer%20greenhouse%20plastic%20film%20premium%20covering%20material%20transparent%20agricultural%20polyethylene%20sheet%20advanced%20UV%20protection%20professional%20product%20photography%20clean%20white%20background%20superior%20quality%20detailed%20texture&width=400&height=300&seq=plastic-5layer&orientation=landscape',
          description: 'پوشش پلاستیکی ۵ لایه پیشرفته با عایق حرارتی عالی',
          features: ['عایق حرارتی پیشرفته', 'ضد قطره و ضد مه', 'محافظت UV ۱۵%', 'عبور نور ۹۰%', 'عمر مفید ۵ سال'],
          specifications: {
            'ضخامت': '۲۵۰ میکرون',
            'عرض': '۸ متر',
            'طول': '۱۰۰ متر',
            'عمر مفید': '۵ سال',
            'محافظت UV': '۱۵%'
          }
        },
        {
          id: 4,
          name: 'توری ضد تریپس',
          category: 'protection',
          price: '۱۲۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture&width=400&height=300&seq=thrips-net&orientation=landscape',
          description: 'توری محافظ در برابر حشرات مضر گلخانه',
          features: ['محافظت از تریپس', 'تهویه مناسب', 'عبور نور', 'مقاوم در برابر UV', 'نصب آسان'],
          specifications: {
            'ابعاد': '۲×۱۰ متر',
            'اندازه چشمه': '۰.۱۵×۰.۳۵ میلی‌متر',
            'رنگ': 'سفید',
            'مواد': 'پلی‌اتیلن'
          }
        },
        {
          id: 1,
          name: 'کوکوپیت پریمیوم',
          category: 'substrates',
          price: '۲۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=400&height=300&seq=coco-premium&orientation=landscape',
          description: 'بستر کشت طبیعی و ارگانیک از الیاف نارگیل با کیفیت بالا',
          features: ['۱۰۰٪ طبیعی و ارگانیک', 'نگهداری آب عالی', 'تهویه مناسب', 'pH متعادل', 'قابل استفاده مجدد'],
          specifications: {
            'حجم': '۵ کیلوگرم',
            'رطوبة': '۱۵-۲۰٪',
            'pH': '۵.۵-۶.۵',
            'EC': '< ۰.۵ mS/cm'
          }
        },
        {
          id: 2,
          name: 'پیت ماس کانادایی',
          category: 'substrates',
          price: '۳۲۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20packaging%20high%20resolution%20product%20photography&width=400&height=300&seq=peat-canadian&orientation=landscape',
          description: 'خاک مخصوص کشت گلخانه‌ای با کیفیت کانادایی',
          features: ['کیفیت کانادایی', 'نگهداری رطوبة بالا', 'ساختار سبک', 'عاری از آفات', 'مناسب همه گیاهان'],
          specifications: {
            'حجم': '۳.۸ کیوبیک فوت',
            'رطوبة': '۴۵-۵۵٪',
            'pH': '۳.۵-۴.۵',
            'درجه تجزیه': 'H2-H4'
          }
        },
        {
          id: 3,
          name: 'نخ UV گلخانه',
          category: 'support',
          price: '۸۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=400&height=300&seq=uv-twine&orientation=landscape',
          description: 'نخ مقاوم در برابر اشعه UV برای نگهداری گیاهان',
          features: ['مقاوم در برابر UV', 'استحکام بالا', 'انعطاف‌پذیر', 'ضد آب', 'قابل بازیافت'],
          specifications: {
            'طول': '۵۰۰ متر',
            'ضخامت': '۲ میلی‌متر',
            'مقاومت کششی': '۱۵ کیلوگرم',
            'مواد': 'پلی‌پروپیلن'
          }
        },
        {
          id: 7,
          name: 'نخ بیلر کشاورزی',
          category: 'support',
          price: '۱۲۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=agricultural%20baler%20twine%20rope%20strong%20polypropylene%20string%20for%20hay%20bales%20farming%20equipment%20white%20background%20professional%20product%20photography%20high%20quality%20durable%20material&width=400&height=300&seq=baler-twine&orientation=landscape',
          description: 'نخ بیلر مقاوم برای بسته‌بندی علوفه و محصولات کشاورزی',
          features: ['مقاومت بالا', 'ضد UV', 'مناسب بیلر', 'قابلیت گره‌زنی عالی', 'طول زیاد'],
          specifications: {
            'طول': '۱۰۰۰ متر',
            'ضخامت': '۳ میلی‌متر',
            'مقاومت کششی': '۲۵ کیلوگرم',
            'مواد': 'پلی‌پروپیلن'
          }
        },
        {
          id: 8,
          name: 'قلاب فلزی تکشیار و دوشیار',
          category: 'accessories',
          price: '۱۲۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=metal%20m%20hook%20galvanized%20steel%20greenhouse%20hanging%20hooks%20single%20and%20double%20agricultural%20equipment%20professional%20product%20photography%20white%20background%20detailed%20view&width=400&height=300&seq=metal-m-hook-product&orientation=landscape',
          description: 'قلاب‌های فلزی گالوانیزه تکشیار و دوشیار برای آویزان کردن گیاهان در گلخانه',
          inStock: true,
          featured: false
        },
        {
          id: 9,
          name: 'نخ نتابیده کشاورزی',
          category: 'support',
          price: '۷۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=untwisted%20agricultural%20twine%20rope%20flat%20polypropylene%20string%20for%20greenhouse%20farming%20white%20background%20professional%20product%20photography%20soft%20flexible%20material&width=400&height=300&seq=untwisted-twine&orientation=landscape',
          description: 'نخ نتابیده با بافت نرم برای کاربردهای حساس',
          features: ['بافت نرم', 'آسیب کمتر به گیاه', 'انعطاف بالا', 'قابل شستشو', 'قابل استفاده مجدد'],
          specifications: {
            'طول': '۶۰۰ متر',
            'عرض': '۴ میلی‌متر',
            'مقاومت کششی': '۱۰ کیلوگرم',
            'مواد': 'پلی‌پروپیلن نتابیده'
          }
        },
        {
          id: 10,
          name: 'نخ گوجه فرنگی',
          category: 'support',
          price: '۱۰۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=tomato%20plant%20support%20twine%20rope%20specialized%20greenhouse%20string%20for%20vertical%20tomato%20growing%20white%20background%20professional%20product%20photography%20strong%20durable%20material&width=400&height=300&seq=tomato-twine&orientation=landscape',
          description: 'نخ تخصصی برای نگهداری و رشد عمودی گوجه فرنگی',
          features: ['مقاومت ویژه', 'ضد UV', 'تحمل وزن بالا', 'مناسب گوجه', 'دوام طولانی'],
          specifications: {
            'طول': '۸۰۰ متر',
            'ضخامت': '۲.۲ میلی‌متر',
            'مقاومت کششی': '۱۸ کیلوگرم',
            'مواد': 'پلی‌پروپیلن تقویت شده'
          }
        },
        {
          id: 11,
          name: 'نخ چند منظوره کشاورزی',
          category: 'support',
          price: '۶۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=multipurpose%20agricultural%20twine%20rope%20versatile%20farming%20string%20for%20various%20crops%20white%20background%20professional%20product%20photography%20durable%20material&width=400&height=300&seq=multipurpose-twine&orientation=landscape',
          description: 'نخ همه‌کاره برای انواع کاربردهای کشاورزی',
          features: ['کاربرد گسترده', 'مقرون به صرفه', 'مقاومت خوب', 'رنگ‌های متنوع', 'آسان الاستفاده'],
          specifications: {
            'طول': '۵۰۰ متر',
            'ضخامت': '۱.۵ میلی‌متر',
            'مقاومت کششی': '۸ کیلوگرم',
            'مواد': 'پلی‌پروپیلن'
          }
        },
        {
          id: 5,
          name: 'چسب ترمیم پلاستیک',
          category: 'tools',
          price: '۴۵,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography%20clear%20material&width=400&height=300&seq=repair-tape&orientation=landscape',
          description: 'چسب شفاف برای ترمیم پلاستیک گلخانه',
          features: ['شفافیت بالا', 'چسبندگی قوی', 'مقاوم در برابر آب و هوا', 'آسان الاستفاده', 'بدون باقی‌مانده'],
          specifications: {
            'عرض': '۵ سانتی‌متر',
            'طول': '۲۵ متر',
            'ضخامت': '۰.۱ میلی‌متر',
            'دمای کاری': '-۲۰ تا +۸۰ درجه'
          }
        },
        {
          id: 6,
          name: 'هیتر تابشی مادون قرمز',
          category: 'heating',
          price: '۱,۸۵۰,۰۰۰ تومان',
          image: 'https://readdy.ai/api/search-image?query=infrared%20radiant%20heater%20for%20greenhouse%20professional%20agricultural%20heating%20equipment%20modern%20design%20white%20background%20industrial%20product%20photography&width=400&height=300&seq=radiant-heater&orientation=landscape',
          description: 'سیستم گرمایشی تابشی برای گلخانه‌های بزرگ',
          features: ['گرمایش یکنواخت', 'صرفه‌جویی انرژی', 'کنترل دقیق دما', 'نصب آسان', 'عمر طولانی'],
          specifications: {
            'قدرت': '۳ کیلووات',
            'ولتاژ': '۲۲۰ ولت',
            'ابعاد': '۱۲۰×۱۵×۱۰ سانتی‌متر',
            'پوشش': '۳۰ متر مربع'
          }
        }
      ];
    }
  };

  const products = [
    {
      id: 18,
      name: 'قلاب فلزی تکشیار و دوشیار',
      category: 'tools',
      price: '۱۲۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20realistic%20galvanized%20steel%20metal%20hooks%20for%20greenhouse%20plant%20support%20shiny%20silver%20metallic%20m%20shaped%20hooks%20single%20and%20double%20wire%20hanging%20clips%20professional%20agricultural%20hardware%20product%20on%20white%20background%20macro%20photography%20sharp%20details&width=400&height=300&seq=metal-hooks-realistic-v2&orientation=landscape',
      description: 'قلاب‌های فلزی گالوانیزه تکشیار و دوشیار برای نگهداری و آویزان کردن گیاهان در گلخانه',
      features: ['گالوانیزه ضد زنگ', 'تکشیار و دوشیار', 'مقاومت بالا', 'نصب آسان', 'قابل استفاده مجدد'],
      specifications: {
        'جنس': 'فولاد گالوانیزه',
        'نوع': 'تکشیار و دوشیار',
        'قطر سیم': '۳-۴ میلی‌متر',
        'ظرفیت بار': '۵-۱۰ کیلوگرم',
        'بسته‌بندی': '۱۰۰ عددی'
      }
    },
    {
      id: 17,
      name: 'سیستم‌های مه‌پاش و آبیاری',
      category: 'irrigation',
      price: '۲,۸۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=modern%20greenhouse%20misting%20and%20irrigation%20system%20high%20pressure%20fogger%20nozzles%20drip%20irrigation%20sprinkler%20system%20professional%20agricultural%20equipment%20clean%20white%20background%20product%20photography&width=400&height=300&seq=irrigation-systems&orientation=landscape',
      description: 'مجموعه کامل سیستم‌های مه‌پاش و آبیاری شامل مه‌پاش فشار بالا، قطره‌ای، اسپرینکلر و نازل‌های مه‌پاش',
      features: ['کنترل دقیق رطوبت', 'صرفه‌جویی ۴۰٪ آب', 'پوشش یکنواخت', 'نصب آسان', 'دوام بالا'],
      specifications: {
        'فشار کاری': '۳-۸ بار',
        'دبی': '۱۰-۵۰ لیتر/ساعت',
        'پوشش': '۵۰-۲۰۰ متر مربع',
        'جنس': 'استیل ضد زنگ و PVC',
        'گارانتی': '۲ سال'
      }
    },
    {
      id: 16,
      name: 'سینی نشا ترک (۲۸ تا ۲۵۶ حفره)',
      category: 'tools',
      price: '۱۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=professional%20greenhouse%20seedling%20trays%20multiple%20sizes%20black%20plastic%20nursery%20trays%20with%20cells%2028%2048%2070%2077%20128%20256%20holes%20agricultural%20equipment%20clean%20white%20background%20high%20quality%20product%20photography&width=400&height=300&seq=seedling-trays-turkish&orientation=landscape',
      description: 'مجموعه کامل سینی‌های نشا ترک با ۶ سایز مختلف: ۲۸، ۴۸، ۷۰، ۷۷، ۱۲۸ و ۲۵۶ حفره',
      features: ['۶ سایز مختلف', 'جنس پلاستیک مقاوم', 'زهکشی مناسب', 'قابل شستشو', 'قابل استفاده مجدد'],
      specifications: {
        'سایزها': '۲۸، ۴۸، ۷۰، ۷۷، ۱۲۸، ۲۵۶ حفره',
        'جنس': 'پلاستیک PS',
        'رنگ': 'مشکی',
        'ابعاد استاندارد': '۵۴×۲۸ سانتی‌متر',
        'ضخامت': '۱.۵-۲ میلی‌متر'
      }
    },
    {
      id: 15,
      name: 'هیترهای گلخانه (۱۰۰-۳۲۰ هزار کالری)',
      category: 'heating',
      price: '۱,۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=industrial%20greenhouse%20spot%20cooler%20heater%20with%20three%20large%20metal%20ducts%20on%20top%20blue%20and%20silver%20body%20portable%20unit%20on%20wheels%20professional%20HVAC%20equipment%20for%20agricultural%20use%20warehouse%20setting&width=400&height=300&seq=heaters-industrial-real&orientation=landscape',
      description: 'مجموعه کامل هیترهای گلخانه با ظرفیت‌های ۱۰۰، ۱۵۰، ۲۵۰ و ۳۲۰ هزار کالری',
      features: ['۴ مدل مختلف', 'گرمایش یکنواخت', 'صرفه‌جویی انرژی ۳۰٪', 'کنترل دقیق دما', 'عمر طولانی ۱۰ سال'],
      specifications: {
        'مدل‌ها': '۱۰۰، ۱۵۰، ۲۵۰، ۳۲۰ هزار کالری',
        'پوشش': '۲۰ تا ۶۵ متر مربع',
        'ولتاژ': '۲۲۰ ولت',
        'سوخت': 'گاز طبیعی/مایع',
        'گارانتی': '۲ سال'
      }
    },
    {
      id: 14,
      name: 'لوله و اتصالات سازه گلخانه',
      category: 'structure',
      price: '۱,۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=greenhouse%20steel%20pipe%20structure%20framework%20galvanized%20metal%20tubes%20and%20connectors%20professional%20agricultural%20construction%20materials%20various%20sizes%20clean%20white%20background%20industrial%20product%20photography&width=400&height=300&seq=structure-pipes&orientation=landscape',
      description: 'مجموعه کامل لوله‌ها و اتصالات گالوانیزه برای ساخت سازه گلخانه',
      features: ['گالوانیزه گرم', 'مقاوم در برابر زنگ', 'استحکام بالا', 'اتصالات استاندارد', 'نصب آسان'],
      specifications: {
        'جنس': 'فولاد گالوانیزه',
        'قطرها': '۲۵، ۳۲، ۴۰، ۵۰ میلی‌متر',
        'ضخامت': '۱.۵-۲ میلی‌متر',
        'طول استاندارد': '۶ متر',
        'استاندارد': 'DIN 2440'
      }
    },
    {
      id: 12,
      name: 'پلاستیک ۳ لایه گلخانه',
      category: 'covering',
      price: '۳۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=three%20layer%20greenhouse%20plastic%20film%20covering%20material%20transparent%20agricultural%20polyethylene%20sheet%20UV%20resistant%20professional%20product%20photography%20clean%20white%20background%20high%20quality%20detailed%20texture&width=400&height=300&seq=plastic-3layer&orientation=landscape',
      description: 'پوشش پلاستیکی ۳ لایه با کیفیت بالا برای گلخانه',
      features: ['ضد قطره (Anti-drip)', 'ضد مه (Anti-fog)', 'محافظت UV ۱۰%', 'عبور نور ۸۵%', 'عمر مفید ۳ سال'],
      specifications: {
        'ضخامت': '۲۰۰ میکرون',
        'عرض': '۸ متر',
        'طول': '۱۰۰ متر',
        'عمر مفید': '۳ سال',
        'محافظت UV': '۱۰%'
      }
    },
    {
      id: 13,
      name: 'پلاستیک ۵ لایه گلخانه',
      category: 'covering',
      price: '۵۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=five%20layer%20greenhouse%20plastic%20film%20premium%20covering%20material%20transparent%20agricultural%20polyethylene%20sheet%20advanced%20UV%20protection%20professional%20product%20photography%20clean%20white%20background%20superior%20quality%20detailed%20texture&width=400&height=300&seq=plastic-5layer&orientation=landscape',
      description: 'پوشش پلاستیکی ۵ لایه پیشرفته با عایق حرارتی عالی',
      features: ['عایق حرارتی پیشرفته', 'ضد قطره و ضد مه', 'محافظت UV ۱۵%', 'عبور نور ۹۰%', 'عمر مفید ۵ سال'],
      specifications: {
        'ضخامت': '۲۵۰ میکرون',
        'عرض': '۸ متر',
        'طول': '۱۰۰ متر',
        'عمر مفید': '۵ سال',
        'محافظت UV': '۱۵%'
      }
    },
    {
      id: 4,
      name: 'توری ضد تریپس',
      category: 'protection',
      price: '۱۲۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture&width=400&height=300&seq=thrips-net&orientation=landscape',
      description: 'توری محافظ در برابر حشرات مضر گلخانه',
      features: ['محافظت از تریپس', 'تهویه مناسب', 'عبور نور', 'مقاوم در برابر UV', 'نصب آسان'],
      specifications: {
        'ابعاد': '۲×۱۰ متر',
        'اندازه چشمه': '۰.۱۵×۰.۳۵ میلی‌متر',
        'رنگ': 'سفید',
        'مواد': 'پلی‌اتیلن'
      }
    },
    {
      id: 1,
      name: 'کوکوپیت پریمیوم',
      category: 'substrates',
      price: '۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography%20detailed%20texture&width=400&height=300&seq=coco-premium&orientation=landscape',
      description: 'بستر کشت طبیعی و ارگانیک از الیاف نارگیل با کیفیت بالا',
      features: ['۱۰۰٪ طبیعی و ارگانیک', 'نگهداری آب عالی', 'تهویه مناسب', 'pH متعادل', 'قابل استفاده مجدد'],
      specifications: {
        'حجم': '۵ کیلوگرم',
        'رطوبة': '۱۵-۲۰٪',
        'pH': '۵.۵-۶.۵',
        'EC': '< ۰.۵ mS/cm'
      }
    },
    {
      id: 2,
      name: 'پیت ماس کانادایی',
      category: 'substrates',
      price: '۳۲۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=Canadian%20peat%20moss%20premium%20quality%20growing%20medium%20for%20greenhouse%20professional%20horticultural%20substrate%20clean%20packaging%20high%20resolution%20product%20photography&width=400&height=300&seq=peat-canadian&orientation=landscape',
      description: 'خاک مخصوص کشت گلخانه‌ای با کیفیت کانادایی',
      features: ['کیفیت کانادایی', 'نگهداری رطوبة بالا', 'ساختار سبک', 'عاری از آفات', 'مناسب همه گیاهان'],
      specifications: {
        'حجم': '۳.۸ کیوبیک فوت',
        'رطوبة': '۴۵-۵۵٪',
        'pH': '۳.۵-۴.۵',
        'درجه تجزیه': 'H2-H4'
      }
    },
    {
      id: 3,
      name: 'نخ UV گلخانه',
      category: 'support',
      price: '۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=400&height=300&seq=uv-twine&orientation=landscape',
      description: 'نخ مقاوم در برابر اشعه UV برای نگهداری گیاهان',
      features: ['مقاوم در برابر UV', 'استحکام بالا', 'انعطاف‌پذیر', 'ضد آب', 'قابل بازیافت'],
      specifications: {
        'طول': '۵۰۰ متر',
        'ضخامت': '۲ میلی‌متر',
        'مقاومت کششی': '۱۵ کیلوگرم',
        'مواد': 'پلی‌پروپیلن'
      }
    },
    {
      id: 7,
      name: 'نخ بیلر کشاورزی',
      category: 'support',
      price: '۱۲۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=agricultural%20baler%20twine%20rope%20strong%20polypropylene%20string%20for%20hay%20bales%20farming%20equipment%20white%20background%20professional%20product%20photography%20high%20quality%20durable%20material&width=400&height=300&seq=baler-twine&orientation=landscape',
      description: 'نخ بیلر مقاوم برای بسته‌بندی علوفه و محصولات کشاورزی',
      features: ['مقاومت بالا', 'ضد UV', 'مناسب بیلر', 'قابلیت گره‌زنی عالی', 'طول زیاد'],
      specifications: {
        'طول': '۱۰۰۰ متر',
        'ضخامت': '۳ میلی‌متر',
        'مقاومت کششی': '۲۵ کیلوگرم',
        'مواد': 'پلی‌پروپیلن'
      }
    },
    {
      id: 8,
      name: 'قلاب فلزی تکشیار و دوشیار',
      category: 'accessories',
      price: '۱۲۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=metal%20m%20hook%20galvanized%20steel%20greenhouse%20hanging%20hooks%20single%20and%20double%20agricultural%20equipment%20professional%20product%20photography%20white%20background%20detailed%20view&width=400&height=300&seq=metal-m-hook-product&orientation=landscape',
      description: 'قلاب‌های فلزی گالوانیزه تکشیار و دوشیار برای آویزان کردن گیاهان در گلخانه',
      features: ['گالوانیزه ضد زنگ', 'تکشیار و دوشیار', 'مقاومت بالا', 'نصب آسان', 'قابل استفاده مجدد'],
      specifications: {
        'جنس': 'فولاد گالوانیزه',
        'نوع': 'تکشیار و دوشیار',
        'قطر سیم': '۳-۴ میلی‌متر',
        'ظرفیت بار': '۵-۱۰ کیلوگرم',
        'بسته‌بندی': '۱۰۰ عددی'
      }
    },
    {
      id: 9,
      name: 'نخ نتابیده کشاورزی',
      category: 'support',
      price: '۷۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=untwisted%20agricultural%20twine%20rope%20flat%20polypropylene%20string%20for%20greenhouse%20farming%20white%20background%20professional%20product%20photography%20soft%20flexible%20material&width=400&height=300&seq=untwisted-twine&orientation=landscape',
      description: 'نخ نتابیده با بافت نرم برای کاربردهای حساس',
      features: ['بافت نرم', 'آسیب کمتر به گیاه', 'انعطاف بالا', 'قابل شستشو', 'قابل استفاده مجدد'],
      specifications: {
        'طول': '۶۰۰ متر',
        'عرض': '۴ میلی‌متر',
        'مقاومت کششی': '۱۰ کیلوگرم',
        'مواد': 'پلی‌پروپیلن نتابیده'
      }
    },
    {
      id: 10,
      name: 'نخ گوجه فرنگی',
      category: 'support',
      price: '۱۰۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=tomato%20plant%20support%20twine%20rope%20specialized%20greenhouse%20string%20for%20vertical%20tomato%20growing%20white%20background%20professional%20product%20photography%20strong%20durable%20material&width=400&height=300&seq=tomato-twine&orientation=landscape',
      description: 'نخ تخصصی برای نگهداری و رشد عمودی گوجه فرنگی',
      features: ['مقاومت ویژه', 'ضد UV', 'تحمل وزن بالا', 'مناسب گوجه', 'دوام طولانی'],
      specifications: {
        'طول': '۸۰۰ متر',
        'ضخامت': '۲.۲ میلی‌متر',
        'مقاومت کششی': '۱۸ کیلوگرم',
        'مواد': 'پلی‌پروپیلن تقویت شده'
      }
    },
    {
      id: 11,
      name: 'نخ چند منظوره کشاورزی',
      category: 'support',
      price: '۶۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=multipurpose%20agricultural%20twine%20rope%20versatile%20farming%20string%20for%20various%20crops%20white%20background%20professional%20product%20photography%20durable%20material&width=400&height=300&seq=multipurpose-twine&orientation=landscape',
      description: 'نخ همه‌کاره برای انواع کاربردهای کشاورزی',
      features: ['کاربرد گسترده', 'مقرون به صرفه', 'مقاومت خوب', 'رنگ‌های متنوع', 'آسان الاستفاده'],
      specifications: {
        'طول': '۵۰۰ متر',
        'ضخامت': '۱.۵ میلی‌متر',
        'مقاومت کششی': '۸ کیلوگرم',
        'مواد': 'پلی‌پروپیلن'
      }
    },
    {
      id: 5,
      name: 'چسب ترمیم پلاستیک',
      category: 'tools',
      price: '۴۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography%20clear%20material&width=400&height=300&seq=repair-tape&orientation=landscape',
      description: 'چسب شفاف برای ترمیم پلاستیک گلخانه',
      features: ['شفافیت بالا', 'چسبندگی قوی', 'مقاوم در برابر آب و هوا', 'آسان الاستفاده', 'بدون باقی‌مانده'],
      specifications: {
        'عرض': '۵ سانتی‌متر',
        'طول': '۲۵ متر',
        'ضخامت': '۰.۱ میلی‌متر',
        'دمای کاری': '-۲۰ تا +۸۰ درجه'
      }
    },
    {
      id: 6,
      name: 'هیتر تابشی مادون قرمز',
      category: 'heating',
      price: '۱,۸۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=infrared%20radiant%20heater%20for%20greenhouse%20professional%20agricultural%20heating%20equipment%20modern%20design%20white%20background%20industrial%20product%20photography&width=400&height=300&seq=radiant-heater&orientation=landscape',
      description: 'سیستم گرمایشی تابشی برای گلخانه‌های بزرگ',
      features: ['گرمایش یکنواخت', 'صرفه‌جویی انرژی', 'کنترل دقیق دما', 'نصب آسان', 'عمر طولانی'],
      specifications: {
        'قدرت': '۳ کیلووات',
        'ولتاژ': '۲۲۰ ولت',
        'ابعاد': '۱۲۰×۱۵×۱۰ سانتی‌متر',
        'پوشش': '۳۰ متر مربع'
      }
    }
  ];

  const filteredProducts = products.filter(product => {
    const matchesCategory = activeCategory === 'all' || product.category === activeCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const getStatsData = () => {
    const currentLang = localStorage.getItem('i18nextLng') || 'fa';
    
    if (currentLang === 'en') {
      return [
        { number: '200+', label: t('products.stats.diverseProducts'), icon: 'ri-box-3-line' },
        { number: '15+', label: t('products.stats.trustedBrands'), icon: 'ri-award-line' },
        { number: '24/7', label: t('products.stats.support247'), icon: 'ri-customer-service-2-line' },
        { number: '100%', label: t('products.stats.qualityGuarantee'), icon: 'ri-shield-check-line' }
      ];
    } else if (currentLang === 'ar') {
      return [
        { number: '200+', label: t('products.stats.diverseProducts'), icon: 'ri-box-3-line' },
        { number: '15+', label: t('products.stats.trustedBrands'), icon: 'ri-award-line' },
        { number: '24/7', label: t('products.stats.support247'), icon: 'ri-customer-service-2-line' },
        { number: '100%', label: t('products.stats.qualityGuarantee'), icon: 'ri-shield-check-line' }
      ];
    } else if (currentLang === 'ru') {
      return [
        { number: '200+', label: t('products.stats.diverseProducts'), icon: 'ri-box-3-line' },
        { number: '15+', label: t('products.stats.trustedBrands'), icon: 'ri-award-line' },
        { number: '24/7', label: t('products.stats.support247'), icon: 'ri-customer-service-2-line' },
        { number: '100%', label: t('products.stats.qualityGuarantee'), icon: 'ri-shield-check-line' }
      ];
    } else {
      return [
        { number: '200+', label: t('products.stats.diverseProducts'), icon: 'ri-box-3-line' },
        { number: '15+', label: t('products.stats.trustedBrands'), icon: 'ri-award-line' },
        { number: '24/7', label: t('products.stats.support247'), icon: 'ri-customer-service-2-line' },
        { number: '100%', label: t('products.stats.qualityGuarantee'), icon: 'ri-shield-check-line' }
      ];
    }
  };

  const stats = getStatsData();

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=modern%20greenhouse%20equipment%20and%20supplies%20professional%20agricultural%20products%20display%20shelves%20with%20various%20tools%20substrates%20heating%20systems%20irrigation%20equipment%20clean%20organized%20warehouse&width=1920&height=600&seq=products-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold">
            {t('products.title')}
          </h1>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-br from-green-600 via-green-700 to-emerald-800 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
          <div className="absolute top-32 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
          <div className="absolute bottom-20 left-1/4 w-40 h-40 border border-white/20 rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-28 h-28 border border-white/20 rounded-full"></div>
        </div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              چرا گلخانه سبز آریا؟
            </h2>
            <p className="text-xl text-green-100 max-w-3xl mx-auto">
              با بیش از ۱۵ سال تجربه، ما بهترین تجهیزات گلخانه‌ای را با کیفیت بین‌المللی ارائه می‌دهیم
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="group">
                <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 text-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-105 border border-white/20">
                  {/* Icon Container */}
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-white/30 to-white/10 rounded-2xl flex items-center justify-center mx-auto group-hover:rotate-12 transition-transform duration-300">
                      <i className={`${stat.icon} text-3xl text-white`}></i>
                    </div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full opacity-80 group-hover:scale-125 transition-transform duration-300"></div>
                  </div>
                  
                  {/* Number */}
                  <div className="text-4xl lg:text-5xl font-bold mb-3 bg-gradient-to-r from-white to-green-100 bg-clip-text text-transparent">
                    {stat.number}
                  </div>
                  
                  {/* Label */}
                  <div className="text-lg font-medium text-green-100 leading-relaxed">
                    {stat.label}
                  </div>
                  
                  {/* Decorative Line */}
                  <div className="w-12 h-1 bg-gradient-to-r from-transparent via-white/50 to-transparent mx-auto mt-4 group-hover:w-16 transition-all duration-300"></div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Additional Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center text-white border border-white/20">
              <i className="ri-medal-line text-3xl text-yellow-300 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">گواهینامه‌های بین‌المللی</h3>
              <p className="text-green-100 text-sm">دارای استانداردهای ISO و CE</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center text-white border border-white/20">
              <i className="ri-global-line text-3xl text-blue-300 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">صادرات به ۱۲ کشور</h3>
              <p className="text-green-100 text-sm">حضور فعال در بازارهای منطقه‌ای</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center text-white border border-white/20">
              <i className="ri-leaf-line text-3xl text-green-300 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">محصولات سازگار با محیط زیست</h3>
              <p className="text-green-100 text-sm">تولید پایدار و مسئولانه</p>
            </div>
          </div>
          
          {/* Call to Action */}
          <div className="text-center mt-12">
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/catalog')}
              className="whitespace-nowrap cursor-pointer font-medium rounded-full transition-all duration-300 flex items-center justify-center shadow-lg hover:shadow-xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-8 py-4 text-lg"
            >
              <i className="ri-download-line ml-2"></i>
              دانلود کاتالوگ محصولات
            </button>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-12">
            <div className="relative">
              <input
                type="text"
                placeholder={t('common.searchPlaceholder')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-6 py-4 pr-12 text-lg border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              />
              <i className="ri-search-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
            </div>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeCategory === category.id
                    ? 'bg-green-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-green-50 border border-gray-200'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {filteredProducts.length} {t('common.found')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('products.subtitle')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="relative">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-48 object-cover object-top"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {t('common.new')}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>
                  
                  {/* Features */}
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-1">
                      {product.features.slice(0, 3).map((feature, index) => (
                        <span key={index} className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  {/* Price */}
                  <div className="flex items-center justify-between mb-4">
                    <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-phone-line ml-1"></i>
                      استعلام قیمت
                    </button>
                    <div className="flex items-center text-yellow-500">
                      <i className="ri-star-fill text-sm"></i>
                      <i className="ri-star-fill text-sm"></i>
                      <i className="ri-star-fill text-sm"></i>
                      <i className="ri-star-fill text-sm"></i>
                      <i className="ri-star-fill text-sm"></i>
                    </div>
                  </div>
                  
                  {/* Buttons */}
                  <div className="flex gap-2">
                    <Link 
                      to={`/products/${product.id}`}
                      className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-full text-center text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-eye-line ml-1"></i>
                      مشاهده جزئیات
                    </Link>
                    <button className="px-3 py-2 border border-gray-300 rounded-full hover:bg-gray-50 cursor-pointer">
                      <i className="ri-heart-line text-gray-600"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Categories Detail */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {t('products.categories')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('products.categoriesSubtitle')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-seedling-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.substrates')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Coconut coir, peat moss and other natural and synthetic growing media for optimal plant growth'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'ألياف جوز الهند وطحلب الخث ووسائط النمو الطبيعية والاصطناعية الأخرى للنمو الأمثل للنباتات'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Кокосовое волокно, торфяной мох и другие натуральные и синтетические среды для выращивания для оптимального роста растений'
                  : 'کوکوپیت، پیت ماس و سایر بسترهای کشت طبیعی و مصنوعی برای رشد بهینه گیاهان'
                }
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-plant-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.support')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Twines, clips and support systems for vertical plant growth support'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'الخيوط والمشابك وأنظمة الدعم لدعم النمو العمودي للنباتات'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Шпагаты, зажимы и системы поддержки для поддержки вертикального роста растений'
                  : 'نخ‌ها، کلیپس‌ها و سیستم‌های نگهداری برای حمایت از رشد عمودی گیاهان'
                }
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.protection')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Screens, shade cloths and protective systems against pests and weather conditions'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'الشاشات وأقمشة الظل والأنظمة الواقية ضد الآفات والظروف الجوية'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Экраны, затеняющие ткани и защитные системы от вредителей и погодных условий'
                  : 'توری‌ها، سایبان‌ها و سیستم‌های محافظتی در برابر آفات و شرایط جوی'
                }
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-fire-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.heating')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Radiant and convection heaters for precise greenhouse temperature control in cold seasons'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'سخانات إشعاعية وحملية للتحكم الدقيق في درجة حرارة البيت المحمي في المواسم الباردة'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Радиационные и конвекционные обогреватели для точного контроля температуры теплицы в холодные сезоны'
                  : 'هیترهای تابشی و همرفتی برای کنترل دقیق دمای گلخانه'
                }
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-tools-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.tools')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Pumps, irrigation systems and measuring tools for greenhouse management'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'المضخات وأنظمة الري وأدوات القياس لإدارة البيت المحمي'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Насосы, системы орошения и измерительные инструменты для управления теплицей'
                  : 'پمپ‌ها، سیستم‌های آبیاری و ابزارهای اندازه‌گیری برای مدیریت گلخانه'
                }
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-settings-4-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('products.cat.smart')}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {localStorage.getItem('i18nextLng') === 'en' 
                  ? 'Sensors and automation systems for smart greenhouse management'
                  : localStorage.getItem('i18nextLng') === 'ar'
                  ? 'أجهزة الاستشعار وأنظمة الأتمتة لإدارة البيت المحمي الذكي'
                  : localStorage.getItem('i18nextLng') === 'ru'
                  ? 'Датчики и системы автоматизации для управления умной теплицей'
                  : 'سنسورها و سیستم‌های اتوماسیون برای مدیریت هوشمند گلخانه'
                }
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Our Products */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {t('products.whyChoose')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('products.whyChooseSubtitle')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t('products.features.qualityGuaranteed')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('products.features.qualityDesc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-truck-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t('products.features.fastShipping')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('products.features.fastShippingDesc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t('products.features.technicalSupport')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('products.features.technicalSupportDesc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-price-tag-3-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t('products.features.fairPrice')}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t('products.features.fairPriceDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technical Support */}
      <section className="py-20 bg-green-600">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">{t('products.techSupport')}</h2>
              <p className="text-lg leading-relaxed mb-6">
                {t('products.techSupportDesc')}
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-green-200"></i>
                  <span className="text-lg">{t('products.support.freeConsultation')}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-green-200"></i>
                  <span className="text-lg">{t('products.support.installationGuide')}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-green-200"></i>
                  <span className="text-lg">{t('products.support.afterSales')}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-2xl text-green-200"></i>
                  <span className="text-lg">{t('products.support.training')}</span>
                </div>
              </div>
              <div className="mt-8">
                <Button variant="outline" size="lg" className="bg-white text-green-600 border-white hover:bg-green-50">
                  <i className="ri-phone-line ml-2"></i>
                  {t('btn.contactExperts')}
                </Button>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20agricultural%20consultant%20helping%20farmer%20in%20modern%20greenhouse%20technical%20support%20expert%20explaining%20equipment%20usage%20Iranian%20specialist%20with%20customer%20clean%20bright%20environment&width=600&height=500&seq=tech-support&orientation=landscape"
                alt={t('products.techSupport')}
                className="rounded-3xl shadow-2xl object-cover object-top w-full h-96"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            {t('products.ctaTitle')}
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            {t('products.ctaSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="min-w-48">
              <i className="ri-shopping-cart-line ml-2"></i>
              {t('btn.viewCatalog')}
            </Button>
            <Button variant="outline" size="lg" className="min-w-48">
              <i className="ri-phone-line ml-2"></i>
              {t('btn.requestConsultation')}
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
